import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    //i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
   // document.documentElement.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr');
   // document.body.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr'); // Update body attribute
      // Refresh the page after a short delay to allow language change to take effect
      setTimeout(() => {
        window.location.reload();
      }, 100);
  };

  return (
    <div>
      {i18n.language === 'ar' ? (
        <button onClick={() => changeLanguage('en')} className="btn btn-dropdown en_font">
          {i18n.t('switch_to_english')}
        </button>
      ) : (
        <button onClick={() => changeLanguage('ar')} className="btn btn-dropdown ar_font">
          {i18n.t('switch_to_arabic')}
        </button>
      )}
    </div>
  );
};

export default LanguageSwitcher;
